export default __webpack_public_path__ + "src/images/packages/monte-vista-boutique-hotel/697eb37fcf208e10a6a9121e27d45f87-3.jpg";